module.exports = __webpack_public_path__ + "img/swan.be5030ca.webp";